import { makeAutoObservable, runInAction } from "mobx";
import { CupCalendarGameType } from "../../schemas/cup_calendar";
import CupService from "../../services/cup_service";
import { CupInfoType } from "../../schemas/cup_info";
import { CupScoreTableType } from "../../schemas/cup_score_table";
import { cupNewsCardType } from "../../schemas/cup_news";

class CupStore {
	constructor() {
		makeAutoObservable(this);
	}

	private _cupInfo: CupInfoType | undefined = undefined;
	get cupInfo() {
		if (!this._cupInfo) this.getCupInfo();
		return this._cupInfo;
	}
	set cupInfo(d: CupInfoType | undefined) {
		this._cupInfo = d;
	}
	private async getCupInfo() {
		const cupInfo = await CupService.getCupInfo();
		runInAction(() => (this.cupInfo = cupInfo));
	}

	private _calendarGames: CupCalendarGameType[] | undefined = undefined;
	get calendarGames() {
		if (!this._calendarGames) this.getCalendarGames();
		return this._calendarGames;
	}
	set calendarGames(d: CupCalendarGameType[] | undefined) {
		this._calendarGames = d;
	}
	private async getCalendarGames() {
		const calendarGames = await CupService.getCupCalendarGames();
		runInAction(() => (this.calendarGames = calendarGames));
	}

	private _newsCards: cupNewsCardType[] | undefined = undefined;
	get newsCards() {
		if (!this._newsCards) this.getCupNewsCards();
		return this._newsCards;
	}
	set newsCards(d: cupNewsCardType[] | undefined) {
		this._newsCards = d;
	}
	private async getCupNewsCards() {
		const newsCards = await CupService.getCupNewsCards();
		runInAction(() => (this.newsCards = newsCards));
	}

	private _scoreTables: CupScoreTableType[] | undefined = undefined;
	get scoreTables() {
		if (!this._scoreTables) this.getCupScoreTables();
		return this._scoreTables;
	}
	set scoreTables(d: CupScoreTableType[] | undefined) {
		this._scoreTables = d;
	}
	private async getCupScoreTables() {
		const scoreTables = await CupService.getCupScoreTables();
		runInAction(() => (this.scoreTables = scoreTables));
	}
}
const cupStore = new CupStore();
export default cupStore;
